import { render, staticRenderFns } from "./EstadosCiviles.vue?vue&type=template&id=ac42ba24&scoped=true"
import script from "./EstadosCiviles.vue?vue&type=script&lang=js"
export * from "./EstadosCiviles.vue?vue&type=script&lang=js"
import style0 from "./EstadosCiviles.vue?vue&type=style&index=0&id=ac42ba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac42ba24",
  null
  
)

export default component.exports